import { Box, Checkbox, FormControlLabel, Paper, Popper } from '@mui/material';

export default function FilterMenu({ anchorEl, open, options, onClose, onChange }) {
  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom-start"
      style={{ zIndex: 1000 }}
    >
      <Paper sx={{ p: 2, mt: 1, width: anchorEl?.offsetWidth+25 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {options.map((option) => (
            <FormControlLabel
              key={option.value}
              control={
                <Checkbox
                  checked={option.checked}
                  disabled={option.disabled ? option.disabled : false}
                  onChange={(e) => onChange(option.value, e.target.checked)}
                />
              }
              label={option.label}
            />
          ))}
        </Box>
      </Paper>
    </Popper>
  );
}